module.exports = __webpack_public_path__ + "assets/quote_avatar_2.e2199d29.png";